//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  methods: {
    /**
     * SPECIFIC_PERSONAL_ORDINARY 个人-普通
     * SPECIFIC_PERSONAL_PROFESSION 个人-专业
     * SPECIFIC_PERSONAL_PRACTITIONERS 个人-从业人员
     * SPECIFIC_ORG_ORDINARY 机构-普通
     * SPECIFIC_ORG_PROFESSION 机构-专业
     * SPECIFIC_ORG_ORG 机构-金融机构
     * SPECIFIC_ORG_PRACTITIONERS 机构-本机构
     * SPECIFIC_ORG_PRODUCT 机构_产品
     * @return {[type]} [description]
     */
    $_format_type (type) {
      let str = ''
      if (type === 'SPECIFIC_PERSONAL_ORDINARY') {
        str = '个人 - 普通'
      }
      if (type === 'SPECIFIC_PERSONAL_PROFESSION') {
        str = '个人 - 专业'
      }
      if (type === 'SPECIFIC_PERSONAL_PRACTITIONERS') {
        str = '个人 - 从业人员'
      }
      if (type === 'SPECIFIC_ORG_ORDINARY') {
        str = '机构 - 普通'
      }
      if (type === 'SPECIFIC_ORG_PROFESSION') {
        str = '机构 - 专业'
      }
      if (type === 'SPECIFIC_ORG_ORG') {
        str = '机构 - 金融机构'
      }
      if (type === 'SPECIFIC_ORG_PRACTITIONERS') {
        str = '机构 - 本机构'
      }
      if (type === 'SPECIFIC_ORG_PRODUCT') {
        str = '机构 - 产品'
      }
      return str
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Relation/index.vue